module.exports = __webpack_public_path__ + "img/7.16b03df4.jpg";